export const appConfigsReducer = (state = {}, action) => {
  switch (action.type) {
    case "SET_APP_CONFIGS":
      return action.payload;
    case "CLEAR_APP_CONFIGS":
      return action.payload;
    default:
      return state;
  }
};
